<template>
	<nav class="top-nav" :class="{ 'nav-scrolled': isScrolled }">
		<div class="nav-container">
			<router-link to="/Home" class="logo" @click="closeMobileMenu">
				<div class="logo-icon">
					<img src="../../assets/image/login02.png" alt="AI助手" />
				</div>
				<div class="container_box">
					<span class="logo-main">中国-东盟建筑工程技术专业AI教学助手</span>
					<span class="logo-sub">AI Teaching Assistant for China ASEAN Construction Engineering Technology Major</span>
				</div>
			</router-link>

			<!-- 桌面端导航 -->
			<div class="nav-actions desktop-nav">
				<!-- <router-link to="/knowledge-graph" class="nav-link">超能力图谱</router-link> -->
				<!-- <a href="#" class="nav-link">教学社区</a>
				<a href="#" class="nav-link">使用指南</a> -->
				<!-- <CoinBalance /> -->
				<UserAvatar />
			</div>

			<!-- 移动端菜单按钮 -->
			<button 
				class="mobile-menu-btn" 
				@click="toggleMobileMenu"
				:class="{ active: showMobileMenu }"
				aria-label="菜单"
			>
				<span></span>
				<span></span>
				<span></span>
			</button>
		</div>

		<!-- 移动端菜单面板 -->
		<div 
			class="mobile-menu" 
			:class="{ 'menu-open': showMobileMenu }"
			v-if="isMobile"
		>
			<div class="mobile-menu-content">
				<!-- 用户信息区域 -->
				<div class="mobile-user-section">
					<UserAvatar />
				</div>

				<!-- 导航链接 -->
				<div class="mobile-nav-links">
					<!-- <router-link to="/knowledge-graph" class="mobile-nav-link" @click="closeMobileMenu">
						<span class="link-icon">🧠</span>
						<span>超能力图谱</span>
					</router-link>
					<a href="#" class="mobile-nav-link" @click="closeMobileMenu">
						<span class="link-icon">👥</span>
						<span>教学社区</span>
					</a>
					<a href="#" class="mobile-nav-link" @click="closeMobileMenu">
						<span class="link-icon">📖</span>
						<span>使用指南</span>
					</a> -->
				</div>

				<!-- 应用信息 -->
				<div class="mobile-app-info">
					<div class="app-version">版本 v1.0.0</div>
				</div>
			</div>
		</div>

		<!-- 移动端遮罩层 -->
		<div 
			class="mobile-overlay" 
			v-if="isMobile && showMobileMenu"
			@click="closeMobileMenu"
		></div>
	</nav>
</template>

<script>
	import CoinBalance from './CoinBalance.vue'
	import UserAvatar from './UserAvatar.vue'
	
	export default {
		name: 'NavBar',
		components: {
			CoinBalance,
			UserAvatar
		},
		
		data() {
			return {
				showMobileMenu: false,
				isMobile: false,
				isScrolled: false
			}
		},

		mounted() {
			this.checkMobile()
			this.handleScroll()
			window.addEventListener('resize', this.checkMobile)
			window.addEventListener('scroll', this.handleScroll)
			document.addEventListener('click', this.handleOutsideClick)
		},

		beforeDestroy() {
			window.removeEventListener('resize', this.checkMobile)
			window.removeEventListener('scroll', this.handleScroll)
			document.removeEventListener('click', this.handleOutsideClick)
		},

		methods: {
			checkMobile() {
				this.isMobile = window.innerWidth <= 768
				// 桌面端自动关闭移动菜单
				if (!this.isMobile) {
					this.showMobileMenu = false
				}
			},

			handleScroll() {
				this.isScrolled = window.scrollY > 10
			},

			toggleMobileMenu() {
				this.showMobileMenu = !this.showMobileMenu
				// 防止背景滚动
				document.body.style.overflow = this.showMobileMenu ? 'hidden' : ''
			},

			closeMobileMenu() {
				this.showMobileMenu = false
				document.body.style.overflow = ''
			},

			handleOutsideClick(event) {
				// 如果点击的不是菜单相关元素，则关闭菜单
				if (this.showMobileMenu && !event.target.closest('.mobile-menu') && !event.target.closest('.mobile-menu-btn')) {
					this.closeMobileMenu()
				}
			}
		}
	}
</script>

<style scoped>
	/* 基础导航栏 */
	.top-nav {
		position: sticky;
		top: 0;
		z-index: 1000;
		background: var(--bg-glass);
		backdrop-filter: blur(var(--blur-lg));
		-webkit-backdrop-filter: blur(var(--blur-lg));
		border-bottom: 1px solid var(--border-light);
		transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
		will-change: transform, box-shadow;
	}

	.top-nav.nav-scrolled {
		box-shadow: var(--shadow-nav);
		background: rgba(255, 255, 255, 0.98);
	}

	.nav-container {
		max-width: 1400px;
		margin: 0 auto;
		padding: 0 20px;
		height: 80px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		transition: height 0.3s ease;
	}

	/* Logo区域 */
	.logo {
		display: flex;
		align-items: center;
		gap: 12px;
		font-size: 24px;
		font-weight: 600;
		color: var(--text-dark);
		cursor: pointer;
		letter-spacing: -0.02em;
		text-decoration: none;
		transition: all 0.3s ease;
		flex-shrink: 0;
	}

	.logo:hover {
		transform: translateY(-1px);
	}

	.logo-icon {
		width: 48px;
		height: 48px;
		background: linear-gradient(135deg, var(--primary), var(--secondary));
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		color: white;
		font-size: 24px;
		flex-shrink: 0;
		box-shadow: 0 4px 16px rgba(0, 122, 255, 0.3);
		animation: glow 4s ease-in-out infinite;
		transition: all 0.3s ease;
		overflow: hidden;
	}

	.logo-icon:hover {
		transform: rotate(5deg) scale(1.05);
		box-shadow: 0 6px 20px rgba(0, 122, 255, 0.4);
	}

	.logo-icon img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.container_box {
		display: flex;
		flex-direction: column;
		min-width: 0;
	}

	.logo-main {
		font-size: 20px;
		font-weight: 600;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		line-height: 1.2;
	}

	.logo-sub {
		font-size: 14px;
		font-weight: 400;
		color: var(--text-light);
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		line-height: 1.3;
		margin-top: 2px;
	}

	/* 桌面端导航 */
	.desktop-nav {
		display: flex;
		align-items: center;
		gap: 24px;
	}

	.nav-link {
		color: var(--text-dark);
		text-decoration: none;
		font-size: 17px;
		font-weight: 500;
		transition: all 0.3s ease;
		white-space: nowrap;
		position: relative;
		letter-spacing: -0.01em;
		padding: 8px 0;
	}

	.nav-link:hover {
		color: var(--primary);
		transform: translateY(-1px);
	}

	.nav-link::after {
		content: '';
		position: absolute;
		bottom: 0;
		left: 0;
		width: 0;
		height: 2px;
		background: linear-gradient(90deg, var(--primary), var(--secondary));
		transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
		border-radius: 1px;
	}

	.nav-link:hover::after {
		width: 100%;
	}

	/* 移动端菜单按钮 */
	.mobile-menu-btn {
		display: none;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		width: 44px;
		height: 44px;
		background: none;
		border: none;
		cursor: pointer;
		padding: 8px;
		border-radius: 8px;
		transition: all 0.3s ease;
		position: relative;
	}

	.mobile-menu-btn:hover {
		background: rgba(0, 122, 255, 0.1);
	}

	.mobile-menu-btn span {
		display: block;
		width: 22px;
		height: 2px;
		background: var(--text-dark);
		border-radius: 2px;
		transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
		transform-origin: center;
	}

	.mobile-menu-btn span:nth-child(1) {
		margin-bottom: 4px;
	}

	.mobile-menu-btn span:nth-child(2) {
		margin-bottom: 4px;
	}

	/* 菜单激活状态 */
	.mobile-menu-btn.active span:nth-child(1) {
		transform: rotate(45deg) translate(5px, 5px);
	}

	.mobile-menu-btn.active span:nth-child(2) {
		opacity: 0;
		transform: scale(0);
	}

	.mobile-menu-btn.active span:nth-child(3) {
		transform: rotate(-45deg) translate(7px, -6px);
	}

	/* 移动端菜单面板 */
	.mobile-menu {
		position: fixed;
		top: 80px;
		right: 0;
		width: 320px;
		max-width: 90vw;
		height: calc(100vh - 80px);
		background: rgba(255, 255, 255, 0.98);
		backdrop-filter: blur(20px);
		-webkit-backdrop-filter: blur(20px);
		border-left: 1px solid var(--border-light);
		transform: translateX(100%);
		transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
		z-index: 999;
		box-shadow: -4px 0 20px rgba(0, 0, 0, 0.1);
	}

	.mobile-menu.menu-open {
		transform: translateX(0);
	}

	.mobile-menu-content {
		padding: 24px;
		height: 100%;
		display: flex;
		flex-direction: column;
		overflow-y: auto;
	}

	.mobile-user-section {
		padding-bottom: 24px;
		border-bottom: 1px solid var(--border-light);
		margin-bottom: 24px;
	}

	.mobile-nav-links {
		flex: 1;
	}

	.mobile-nav-link {
		display: flex;
		align-items: center;
		gap: 16px;
		padding: 16px 0;
		color: var(--text-dark);
		text-decoration: none;
		font-size: 16px;
		font-weight: 500;
		transition: all 0.3s ease;
		border-radius: 8px;
		position: relative;
	}

	.mobile-nav-link:hover {
		color: var(--primary);
		background: rgba(0, 122, 255, 0.05);
		padding-left: 12px;
	}

	.link-icon {
		font-size: 20px;
		width: 24px;
		text-align: center;
	}

	.mobile-app-info {
		padding-top: 24px;
		border-top: 1px solid var(--border-light);
		text-align: center;
	}

	.app-version {
		font-size: 14px;
		color: var(--text-light);
	}

	/* 移动端遮罩层 */
	.mobile-overlay {
		position: fixed;
		top: 80px;
		left: 0;
		right: 0;
		bottom: 0;
		background: rgba(0, 0, 0, 0.3);
		z-index: 998;
		animation: fadeIn 0.3s ease;
	}

	/* 动画效果 */
	@keyframes glow {
		0%, 100% {
			box-shadow: 0 4px 16px rgba(0, 122, 255, 0.3);
		}
		50% {
			box-shadow: 0 4px 20px rgba(0, 122, 255, 0.5);
		}
	}

	@keyframes fadeIn {
		from {
			opacity: 0;
		}
		to {
			opacity: 1;
		}
	}

	/* 平板设备优化 (768px - 1024px) */
	@media (max-width: 1024px) and (min-width: 769px) {
		.nav-container {
			padding: 0 16px;
		}

		.logo {
			font-size: 22px;
		}

		.logo-main {
			font-size: 18px;
		}

		.logo-sub {
			font-size: 13px;
		}

		.desktop-nav {
			gap: 20px;
		}

		.nav-link {
			font-size: 16px;
		}
	}

	/* 移动端优化 (≤768px) */
	@media (max-width: 768px) {
		.nav-container {
			height: 64px;
			padding: 0 16px;
		}

		.top-nav.nav-scrolled .nav-container {
			height: 60px;
		}

		.logo {
			font-size: 18px;
			gap: 10px;
		}

		.logo-icon {
			width: 40px;
			height: 40px;
			font-size: 20px;
		}

		.logo-main {
			font-size: 16px;
		}

		.logo-sub {
			font-size: 12px;
		}

		.desktop-nav {
			display: none;
		}

		.mobile-menu-btn {
			display: flex;
		}

		.mobile-menu {
			top: 64px;
			height: calc(100vh - 64px);
		}

		.mobile-overlay {
			top: 64px;
		}
	}

	/* 小屏手机优化 (≤480px) */
	@media (max-width: 480px) {
		.nav-container {
			padding: 0 12px;
			height: 60px;
		}

		.top-nav.nav-scrolled .nav-container {
			height: 56px;
		}

		.logo {
			font-size: 16px;
			gap: 8px;
		}

		.logo-icon {
			width: 36px;
			height: 36px;
			font-size: 18px;
		}

		.logo-main {
			font-size: 14px;
		}

		.logo-sub {
			display: none; /* 小屏隐藏副标题 */
		}

		.mobile-menu-btn {
			width: 40px;
			height: 40px;
		}

		.mobile-menu-btn span {
			width: 20px;
		}

		.mobile-menu {
			width: 280px;
			top: 60px;
			height: calc(100vh - 60px);
		}

		.mobile-overlay {
			top: 60px;
		}

		.mobile-menu-content {
			padding: 20px;
		}
	}

	/* 超小屏优化 (≤360px) */
	@media (max-width: 360px) {
		.nav-container {
			padding: 0 8px;
		}

		.logo {
			font-size: 14px;
		}

		.logo-main {
			font-size: 13px;
		}

		.logo-icon {
			width: 32px;
			height: 32px;
		}

		.mobile-menu {
			width: 260px;
		}
	}

	/* 横屏模式优化 */
	@media (max-height: 500px) and (orientation: landscape) {
		.nav-container {
			height: 56px;
		}

		.logo {
			font-size: 16px;
		}

		.logo-icon {
			width: 36px;
			height: 36px;
		}

		.logo-main {
			font-size: 14px;
		}

		.logo-sub {
			display: none;
		}

		.mobile-menu {
			top: 56px;
			height: calc(100vh - 56px);
		}

		.mobile-overlay {
			top: 56px;
		}
	}

	/* 高DPI屏幕优化 */
	@media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
		.mobile-menu-btn span {
			height: 1.5px;
		}

		.nav-link::after {
			height: 1.5px;
		}
	}

	/* 触摸设备优化 */
	@media (hover: none) and (pointer: coarse) {
		.logo:hover {
			transform: none;
		}

		.logo-icon:hover {
			transform: none;
		}

		.nav-link:hover {
			transform: none;
			color: var(--text-dark);
		}

		.nav-link::after {
			display: none;
		}

		.mobile-menu-btn:hover {
			background: none;
		}

		.mobile-nav-link:hover {
			background: none;
			padding-left: 0;
		}

		/* 触摸反馈 */
		.logo:active {
			transform: scale(0.98);
		}

		.mobile-menu-btn:active {
			background: rgba(0, 122, 255, 0.1);
			transform: scale(0.95);
		}

		.mobile-nav-link:active {
			background: rgba(0, 122, 255, 0.05);
		}
	}

	/* 无障碍优化 */
	@media (prefers-reduced-motion: reduce) {
		.top-nav,
		.nav-container,
		.logo,
		.logo-icon,
		.nav-link,
		.mobile-menu-btn,
		.mobile-menu-btn span,
		.mobile-menu,
		.mobile-nav-link {
			transition: none;
			animation: none;
		}

		.logo:hover,
		.logo-icon:hover,
		.nav-link:hover {
			transform: none;
		}
	}

	/* 深色模式支持 */
	@media (prefers-color-scheme: dark) {
		:root {
			--bg-glass: rgba(45, 55, 72, 0.95);
			--border-light: rgba(255, 255, 255, 0.1);
			--text-dark: #f7fafc;
			--text-light: #a0aec0;
			--shadow-nav: 0 2px 20px rgba(0, 0, 0, 0.3);
		}

		.top-nav.nav-scrolled {
			background: rgba(45, 55, 72, 0.98);
		}

		.mobile-menu {
			background: rgba(45, 55, 72, 0.98);
		}

		.mobile-menu-btn span {
			background: var(--text-dark);
		}

		.mobile-overlay {
			background: rgba(0, 0, 0, 0.5);
		}
	}

	/* 打印样式 */
	@media print {
		.top-nav {
			position: static;
			background: white;
			backdrop-filter: none;
			border-bottom: 1px solid #ddd;
			box-shadow: none;
		}

		.mobile-menu-btn,
		.mobile-menu,
		.mobile-overlay {
			display: none;
		}

		.nav-container {
			height: auto;
			padding: 10px 0;
		}

		.logo-sub {
			display: block;
		}

		.desktop-nav {
			display: none;
		}
	}
</style>